import { Component, OnInit, Input } from '@angular/core';
import {Location} from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { ProductSearch } from '../../infrastructure/model/classes/productSearch.class';
import { SxHttpService } from '../../infrastructure/services/sxHttp.service';
import { SxContextService } from '../../infrastructure/services/sxContext.service';
import { AlertService, GrowlType } from '../../infrastructure/services/alert.service';
import { Translator } from 'angular-translator';

interface Order {
  title: string;
  value: string;
}

interface FilterItem {
  value: string;
  selected: boolean;
}

interface Filter {
  section: FilterItem[];
  insurer: FilterItem[];
}

@Component({
  selector: 'product-search-component',
  templateUrl: './product-search.component.html',
  styleUrls: ['./product-search.component.css'],
})
export class ProductSearchComponent implements OnInit {
  codorganizacion:string;
  codSistema;
  search = '';
  isLoading: Boolean = true;
  isSelect: Boolean = true;
  orders: Order[] = [{
    title: 'Section',
    value: 'section',
  },
  {
    title: 'Provider',
    value: 'provider',
  }];
  selectedOrder: string = this.orders[0].value;
  selectedProduct: ProductSearch = null;
  items: ProductSearch[] = [];
  filteredProducts: ProductSearch[] = [];
  filters: Filter;
  codNegocio: string;
  codProducto: string;
  constructor(private modalService: NgbModal,
    private aRoute: ActivatedRoute,
    private router: Router,
    public sxContextService: SxContextService,
    private sxHttp: SxHttpService,
    private alertService: AlertService,
    private _location: Location,
    private translate: Translator) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codProducto = params['codproducto'];
      this.codorganizacion = params["codorganizacion"];
      this.isSelect = this.codNegocio !== undefined && this.codProducto !== undefined;
      this.sxHttp
        .get(`api/productSearch/${this.codSistema}`)
        .map(result => result.json().data as ProductSearch[])
        .subscribe((products: ProductSearch[]) => {
          this.items = products;
          this.filteredProducts = products;
          this.resetFilters();
          this.isLoading = false;
        });
    });
  }

  clickNuevo() {
    
  }

  clickEditar() {
    const url = ['nuevoBackoffice', this.selectedProduct.provider.toLowerCase(),
                 this.selectedProduct.id].join('/');
    this.router.navigate([url], { relativeTo: this.aRoute })
               .then(success => {
                 if (!success) {
                   this.alertService.showGrowl({
                    type: GrowlType.DANGER,
                    body: 'SOC_FE_0001_ERROR',
                  });
                 }
               })
               .catch(reason => {
                this.alertService.showGrowl({
                  type: GrowlType.DANGER,
                  body: 'SOC_FE_0001_ERROR',
                });
               });
  }
  addToProduct() {
    const url = `api/configuracionOpcion/${this.codSistema}/${this.codNegocio}/${this.codProducto}/${this.selectedProduct.id}`;

    this.sxHttp
      .post(url, null).toPromise()
      .then(response => {
        this.isLoading = false;
        this.alertService.showSuccessMessage('SOC_FE_0001_SUCCESS');
        this.router.navigate([`soc/organizations/${this.codorganizacion}/subscriptions/${this.codSistema}/channels/${this.codNegocio}/products/${this.codProducto}/confProducto/confOpciones`]);
      });
  }

  open(content) {
    // Back-up filters
    const copyFilters = _.cloneDeep(this.filters);

    this.modalService.open(content)
      .result.then((result) => {
        this.applyFilter();
      }, (reason) => {
        // In case of dismiss or cancel, restore filters from backup
        this.filters = _.cloneDeep(copyFilters);
      });
  }

  applySearch() {

    if(this.selectedOrder == 'provider'){
      this.filteredProducts = this.items.filter(item => item.insurer.toUpperCase().includes(this.search.toUpperCase()));
    }else if(this.selectedOrder == 'section'){
      this.filteredProducts = this.items.filter(item => item.section.toUpperCase().includes(this.search.toUpperCase()));
    }

    this.selectedProduct = null;
  }

  applyFilter() {
    this.applySearch();
    const selectedProviders = this.filters.section.filter(filter => filter.selected)
      .map(filter => filter.value);
    const selectedInsurers = this.filters.insurer.filter(filter => filter.selected)
      .map(filter => filter.value);

    this.filteredProducts = this.filteredProducts.filter(product => {
      if (selectedProviders.indexOf(product.section) >= 0 &&
        selectedInsurers.indexOf(product.insurer) >= 0) {
        return true;
      }
      return false;
    });
  }

  productSelected(product: ProductSearch) {
    this.selectedProduct = product;
  }

  getOtherProducts() {
    return  _.uniqBy(this.items
                         .filter(product => (product.id !== this.selectedProduct.id &&
                                             product.insurer === this.selectedProduct.insurer)),
                                 p => p.provider)
             .map(product => product.section);
  }

  getProvidersForProduct() {
    return _.uniqBy(this.items
                        .filter(product => (product.section === this.selectedProduct.section &&
                                            product.insurer === this.selectedProduct.insurer)),
                    p => p.provider )
            .map(product => product.provider);
  }

  resetFilters() {
    this.filters = {
      section: [],
      insurer: [],
    };

    this.items.forEach(product => {
      this.addIfNotExists(this.filters.section, product.section);
      this.addIfNotExists(this.filters.insurer, product.insurer);
    });
  }

  addIfNotExists(collection: FilterItem[], value: string) {
    const exists = collection.find(item => item.value === value);
    if (!exists) {
      collection.push({ value, selected: true });
    }
  }
  volver() {
      this.router.navigate(['../'], { relativeTo: this.aRoute.parent });
    }
}




// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product-search/product-search.component.ts